export default __webpack_public_path__ + "static/media/solucao-10.a76762c4.webp";